<ul class="nav nav-tabs">
  <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [hidden]="tab.hide"
      class="nav-item" [class.active]="tab.active" [class.ng-invalid]="tab.isInvalid" >
    <a [ngClass]="{active: tab.active, 'ng-invalid': tab.isInvalid}">{{tab.title}}</a>
  </li>
</ul>
<ng-content></ng-content>
